import React, { useEffect, useRef, useState } from 'react'
import { TextInput, StyleSheet, Platform, Keyboard } from 'react-native'
import { ThemedView } from '@app/theme'
import { useTheme } from '@shopify/restyle'
import { Theme } from '@app/theme'
import InputText from '@app/sharedComponents/TextInput/TextInput'
import SearchIcon from '@app/assets/svg/SearchIcon'

const SearchBank = ({ searchText, setSearchText }: { searchText: string, setSearchText: (text: string) => void }) => {
  const { colors } = useTheme<Theme>()

  const ref = useRef<TextInput>(null)

     useEffect(() => {
          if (Platform.OS !== 'web') {
              const timeout = setTimeout(() => {
                  if (ref?.current) {
                      Keyboard.dismiss()
                      ref?.current?.focus()
                  }
              }, 500)
  
              return () => {
                  clearTimeout(timeout)
              }
          }
      }, [])



  return (
    <ThemedView mb="2xl">
      <InputText
        ref={ref}
        placeHolder={'Search by bank name'}
        keyboardType="default"
        showLabel={true}
        autoFocus={Platform.OS === 'web'}
        value={searchText}
        label='Search bank'
        showAnimation
        onChangeText={(e) => {
          if (e !== " ") {
            setSearchText(e)
        }
        }}
        rightAccessory={() => <SearchIcon size={24} color={colors['icon-primary']} />}
        showErrorMessage={false}
        showErrorMessageInFocus={true}
        showRightAccessory={true}
      />
    </ThemedView>
  )
}

export default SearchBank

const styles = StyleSheet.create({
  input: {
    height: 48,
    borderWidth: 1,
    borderRadius: 4,
    paddingHorizontal: 16,
    outlineStyle: 'none',
    outlineWidth: 0,
  },
})
